<template>
    <div class="accordion-item">
        <h3 class="accordion-header" id="grade-level-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#grade-level-collapse" aria-expanded="true" aria-controls="grade-level-collapse">
                <span class="flex-grow-1">Grade Level</span>
                <span class="me-2 badge rounded-pill bg-primary">{{ selected.length }}</span>
            </button>
        </h3>
        <div id="grade-level-collapse" class="accordion-collapse collapse" aria-labelledby="grade-level-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <multiselect
                    v-model="selected"
                    :options="grades"
                    :multiple="true"
                    group-values="grades"
                    group-label="group"
                    :group-select="true"
                    placeholder="Select grade level"
                    track-by="grade"
                    label="name"
                    @input="update"
                ></multiselect>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies';

export default {
    components: { Multiselect, VueCookies },

    props: {
        value: {
            type: Array,
            default: [],
        },
    },

    data() {
        return {
            grades: [
                {
                    group: 'High School',
                    grades: [
                        { name: '12th', grade: 12 },
                        { name: '11th', grade: 11 },
                        { name: '10th', grade: 10 },
                        { name: '9th', grade: 9 },
                    ]
                },
                {
                    group: 'Middle School',
                    grades: [
                        { name: '8th', grade: 8 },
                        { name: '7th', grade: 7 },
                        { name: '6th', grade: 6 }
                    ]
                },
                {
                    group: 'Elementary School',
                    grades: [
                        { name: '5th', grade: 5 },
                        { name: '4th', grade: 4 },
                        { name: '3rd', grade: 3 },
                        { name: '2nd', grade: 2 },
                        { name: '1st', grade: 1 },
                        { name: 'Kindergarten', grade: 0 }
                    ]
                },
            ],

            selected: []
            
        }
    },

    mounted() {
        if (VueCookies.isKey('gl')) {
            this.selected = VueCookies.get('gl');
        }
    },

    methods: {
        store: function() {
            VueCookies.set('gl', JSON.stringify(this.selected), Infinity);
        },

        clear: function() {
            this.selected = [];
            this.store();
        },

        update: function(e) {
            this.$emit('input', this.selected);
            this.store();
        },
    },

}
</script>